import { defineMessages } from '@/hooks/useTranslation';

export default defineMessages({
  content: {
    title: {
      de: '404',
      en: '404'
    },
    message: {
      de: 'Ups! Seite nicht gefunden',
      en: 'Oops! Page not found'
    },
    returnHome: {
      de: 'Zurück zur Startseite',
      en: 'Return to Home'
    }
  }
}); 